import type { AreaData, AtLeast, WamFile } from "@workadventure/map-editor";
import { UpdateAreaCommand } from "@workadventure/map-editor";
import type { AreaEditorTool } from "../../Tools/AreaEditorTool";
import type { FrontCommandInterface } from "../FrontCommandInterface";
import type { RoomConnection } from "../../../../../Connection/RoomConnection";
import type { GameMapFrontWrapper } from "../../../GameMap/GameMapFrontWrapper";
import { analyticsClient } from "../../../../../Administration/AnalyticsClient";

export class UpdateAreaFrontCommand extends UpdateAreaCommand implements FrontCommandInterface {
    constructor(
        wamFile: WamFile,
        dataToModify: AtLeast<AreaData, "id">,
        commandId: string | undefined,
        oldConfig: AtLeast<AreaData, "id"> | undefined,
        private areaEditorTool: AreaEditorTool,
        private gameMapFrontWrapper: GameMapFrontWrapper,
    ) {
        super(wamFile, dataToModify, commandId, oldConfig);
    }

    public async execute(): Promise<void> {
        const returnVal = await super.execute();
        this.areaEditorTool.handleAreaUpdate(this.oldConfig, this.newConfig);

        this.gameMapFrontWrapper.recomputeAreasCollisionGrid();

        return returnVal;
    }

    public getUndoCommand(): UpdateAreaFrontCommand {
        return new UpdateAreaFrontCommand(
            this.wamFile,
            this.oldConfig,
            undefined,
            this.newConfig,
            this.areaEditorTool,
            this.gameMapFrontWrapper,
        );
    }

    public setNewConfig(newConfig: AtLeast<AreaData, "id">): void {
        this.newConfig = newConfig;
    }

    public emitEvent(roomConnection: RoomConnection): void {
        roomConnection.emitMapEditorModifyArea(this.commandId, this.newConfig);
        analyticsClient.trackAdminEvent("map_editor.area.updated", { areaType: this.newConfig.name });
    }
}
